import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconRankTracker(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
        <path d="m3 27h26v1h-26z" />
      </g>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path d="m23.5 5.5h3v19h-3z" />
        <path d="m17.5 13.5h3v11h-3z" />
        <path d="m5.5 15.5h3v9h-3z" />
        <path d="m11.5 10.5h3v14h-3z" />
      </g>
    </Icon>
  )
}
